<template>
  <div class="position-relative">
    <b-tabs v-model="tab" @input="changeTab">
      <b-tab :title="$t('views.skills.skills_list.all')"/>
      <b-tab :title="$t('views.skills.skills_list.connected_with_competences')"/>
      <b-tab :title="$t('views.skills.skills_list.not_connected_with_competences')"/>
    </b-tabs>
    <transition type="slide" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SkillsList',
  watch: {
    '$route.name' (newValue) {
      this.tab = this.tabs.indexOf(newValue)
    }
  },
  data () {
    return {
      tab: 1,
      tabs: [
        'skills_list_all_tab_path',
        'skills_list_connected_with_competences_tab_path',
        'skills_list_not_connected_with_competences_tab_path'
      ]
    }
  },
  methods: {
    changeTab (event) {
      const targetTab = this.tabs[event]

      if (this.$route.name !== targetTab) {
        this.$router.push({ name: targetTab })
      }
    }
  },
  mounted () {
    this.tab = this.tabs.indexOf(this.$route.name)
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/stylesheets/vars";

  .new-message-btn-container {
    right: 0;
    position: absolute;
    width: fit-content;
    background-color: $pcg-the-lightest-gray;
    padding-left: $pcg-m-md;
  }

  @media(max-width: $screen-sm-min) {
    .new-message-btn-container {
      background-color: transparent;
      position: relative;
      margin-left: auto;
    }
  }
</style>
